module.exports = __webpack_public_path__ + "static/img/figma.54bb253c.svg";